import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { AddCircle, Delete } from '@mui/icons-material';

import { useAuthContext } from '../../../context/AuthContext';

import ScrollBox from '../../../components/ScrollBox';
import CtrlFillLabelTxtField from '../../../components/CtrlFillLabelTxtField';
import BgBoxOld from '../../../components/BgBoxOld';
import CtrlCustomDropDownOld from '../../../components/CtrlCustomDropDownOld';
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import { customAlert, notify } from '../../../components/notify';
import CustomDropDown from '../../../components/CustomDropDown';

import { addPoServ, getCompaniesServ } from '../../../services/com-service';
import { getProjByComServ } from '../../../services/proj-service';

import QueryKey from '../../../utils/QueryKey';
import { isNotEmpty, checkNumFormat } from '../../../utils/format';
import constants from '../../../utils/Constants';

import { useQuery } from 'react-query';

const prodStatusArr = [
    { value: "awaiting_post_po_clarify", label: "AWAITING POST-PO CLARIFICATION" },
    { value: "packing_in_prog", label: "PACKING IN PROGRESS" },
    { value: "material_ready", label: "MATERIAL IS READY" },
    { value: "awaiting_sdo_dhl_pickup", label: "AWAITING SDO/DHL PICK-UP" },
    { value: "back_order", label: "BACK ORDER" },
    { value: "partially_del", label: "PARTIALLY DELIVERED" },
    { value: "del_completed", label: "DELIVERY COMPLETED" }];

const paidArr = [
    { value: "1", label: "YES" },
    { value: "0", label: "NO" }];


const userTypeArr = [
    ...(constants.needRequestor ? [{ value: "requestor", label: "Requestor" }] : []),
    { value: "approver", label: "End User" },];

function AddPotPage() {
    const theme = useTheme();
    const location = useLocation();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const projIdStrg = "PJ";
    const comId = ctxtUser?.comId;
    const navigate = useNavigate();
    const txtFieldProps = { fontSize: 12, height: 35 };
    const [formErrors, setFormErrors] = useState({});
    const [inputObject, setInputObject] = useState({
            poReqNo: "",
            delLocation: "",
            // ... other fields
        });
    const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }
    useEffect(() => {
        console.log('Page (or component) loaded');
    }, []); // Empty dependency array = run once on mount
    // const projData = {};
    const [selection, setSelection] = useState({ userType: userTypeArr[0].value, projIdStrg: projIdStrg ?? "", deptId: "" });
    
    const { isLoading, isError, error, data: comArr } = useQuery([QueryKey.comList],
        () => getCompaniesServ(ctxtUser?.userType, ctxtUser?.userId), {
        refetchOnMount: true,
        refetchOnWindowFocus: false
    });

    const companyOptions = comArr?.map((c) => ({
        value: c.id,
        label: c.comName
        })) || [];

    const {
    isLoading: isLoadingP,
    isError: isErrorP,
    error: errorP,
    data: projData
    } = useQuery(
    [QueryKey.projListDD, selection.companyId, ctxtUser?.userId],
    () => {
        return getProjByComServ({ userId: ctxtUser?.userId, userType: 'sourcing', comId: selection.companyId })},
    {
        enabled: isNotEmpty(selection.companyId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: true
    }
    );

    const projectOptions = projData?.projArr?.map((c) => ({
        value: c.projIdStrg,
        label: c.projName
        })) || [];



    const [products, setProducts] = useState([
        {
            lineNo: "",
            comProdIdStrg: "",
            mfrName: "",
            prodName: "",
            orderedQty: "",
            deliveredQty: "",
            balQty: "",
            prodStatus: "",
            expecDelDate: "",
            estTimeArr: "",
            isPaid: "",
            amtcRemarks: ""
        },
    ]);

    // useEffect(() => {
    //     if (!comId) {
    //         notify("error", "Company not found!--");
    //         navigate(-1);
    //     } else {
    //         setSelComValue({ comId, comName, comLogo, potProjDet })
    //     }
    // }, [comId, comName, comLogo, potProjDet]);



    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const formObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(formObject);

        const hasValidProducts =
            products.length > 0 &&
            products.every((product) => {
                return isNotEmpty(product.orderedQty)
            });

        if (!hasValidProducts) {
            errorsObj = {
                ...errorsObj,
                products: "Please check products for any missing data. Remove empty products before Submit.",
            }
        } 
        setFormErrors(errorsObj);        
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                comId: selection.companyId, 
                poReqNo: formObject.poReqNo, 
                delLocation: formObject.delLocation,
                projIdStrg: formObject.projIdStrg,
                poProdArr: products.map((product) => ({
                    ...product,
                    lineNo: checkNumFormat(product.lineNo),
                    orderedQty: checkNumFormat(product.orderedQty),
                    deliveredQty: checkNumFormat(product.deliveredQty),
                    balQty: checkNumFormat(product.balQty),
                    isPaid: checkNumFormat(product.isPaid),
                })),
            }
            console.dir(payload);
            const { message } = await addPoServ(payload);
            notify("success", message);

            document.getElementById("addPo").reset();
            setProducts([
                {
                    lineNo: "",
                    comProdIdStrg: "",
                    mfrName: "",
                    prodName: "",
                    orderedQty: "",
                    deliveredQty: "",
                    balQty: "",
                    prodStatus: "",
                    expecDelDate: "",
                    estTimeArr: "",
                    isPaid: "",
                    amtcRemarks: "",
                    // doDataArr: [],
                },
            ]);
            // navigate(`${route.amtcPoTrackingList}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    async function handleCancel() {
        // navigate(`${route.amtcPoTrackingList}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
    }

    function validate(values) {
        const errors = {};
        if (!values.poReqNo)
            errors.poReqNo = "PO NUMBER is required!";

        if(!values.projIdStrg)
            errors.projId = "Project is required!";

        if(!values.companyId)
            errors.companyId = "Company is required!";

        return errors;
    };

    function handleDDChange(e) {
        const { name, value } = e.target;
        if (name === "projIdStrg")
        setSelection((e) => { return { ...e, projIdStrg: value, deptId: "" } });
        else if (name === "deptId")
        setSelection((e) => { return { ...e, deptId: value } });
        else
        setSelection((e) => { return { ...e, [name]: value } });
    }

    function handleCompanyChange(e) {
        const { name, value } = e.target;
        setSelection((prev) => ({ ...prev, companyId: value, deptId: "", projIdStrg: "" }));
    }


    const addProduct = () => {
        setProducts([
            ...products,
            {
                lineNo: "",
                comProdIdStrg: "",
                mfrName: "",
                prodName: "",
                orderedQty: "",
                deliveredQty: "",
                balQty: "",
                prodStatus: "",
                expecDelDate: "",
                estTimeArr: "",
                isPaid: "",
                amtcRemarks: "",
                // doDataArr: [],
            },
        ]);
    };

    // const addDeliveryOrder = (prodIndex) => {
    //     const updatedProducts = [...products];
    //     updatedProducts[prodIndex].doDataArr.push({
    //         doLineNo: "",
    //         doIdStrg: "",
    //         deliveredQty: "",
    //         deliveredAt: ""
    //     });
    //     setProducts(updatedProducts);
    // };

    const removeProduct = (index) => {
        const updatedProducts = [...products];
        updatedProducts.splice(index, 1);
        setProducts(updatedProducts);
    };

    // const removeDeliveryOrder = (prodIndex, doIndex) => {
    //     const updatedProducts = [...products];
    //     updatedProducts[prodIndex].doDataArr.splice(doIndex, 1);
    //     setProducts(updatedProducts);
    // };

    const handleProdValChange = (index, e) => {
        const { name: field, value } = e.target;
        const updatedProducts = [...products];
        updatedProducts[index][field] = value;
        setProducts(updatedProducts);
    };


    // const handleDoValChange = (prodIndex, doIndex, e) => {
    //     const { name: field, value } = e.target;
    //     const updatedProducts = [...products];
    //     updatedProducts[prodIndex].doDataArr[doIndex][field] = value;
    //     setProducts(updatedProducts);
    // };

    // ✅ All hooks at top level
    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        setLoadingScreen(isLoadingP);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingP]);

    // ✅ Only after hooks: conditionally render
    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>;
    }

    if (isErrorP) {
        customAlert(errorP);
        return <h2>Something went wrong</h2>;
    }


    return (
        <Stack height={"100%"} width={"100%"}>
            <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%" }}>
                <Stack direction={'row'} justifyContent='space-between' alignItems='center' my={1} pl={5} pr={10}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>ADD PURCHASE ORDER</Typography>
                    <Stack direction={'row'} alignItems='center' gap={1} >
                        <Button variant="text" sx={{ height: 30, width: 120, color: theme.palette.custom.btn }} onClick={handleCancel}>{"Cancel"}</Button>
                        <Button variant="contained" type='submit' sx={{ height: 30, width: 120, color: "white", backgroundColor: theme.palette.custom.btn }}>{"ADD PO"}</Button>
                    </Stack>
                </Stack>
                <BgBoxOld height={"93%"} py={1}>
                    <Stack direction={"row"} gap={2} alignItems={"center"}>
                        <CustomDropDown
                            bgColor={"rgba(162, 214, 249, 0.18)"}
                            defaultValue={comArr?.[0]?.comName || "None"}
                            name="companyId"
                            title={"Company"}
                            {...txtFieldSx}
                            errMsg={formErrors.companyId}
                            handleDDChange={handleCompanyChange}
                            value={selection?.companyId}
                            ddArr={companyOptions || []}
                            />
                        <CustomDropDown bgColor={"rgba(162, 214, 249, 0.18)"} defaultValue={projData?.projArr[0].projIdStrg} name="projIdStrg"
                                    title={"Project"} {...txtFieldSx} errMsg={formErrors.projId} handleDDChange={handleDDChange} 
                                    value={selection?.projIdStrg} ddArr={projectOptions || []} />
                        <FillLabelTxtField name="poReqNo" title={"PO NUMBER"} 
                        value={inputObject.poReqNo}
                        onChange={(e) => setInputObject({ ...inputObject, poReqNo: e.target.value })} 
                        errMsg={formErrors.poReqNo} {...txtFieldProps} />
                        {/* <Box width={100} /> */}
                        <FillLabelTxtField name="delLocation" title={"DELIVERY LOCATION"} 
                        value={inputObject.delLocation}
                        onChange={(e) => setInputObject({ ...inputObject, delLocation: e.target.value })}
                        {...txtFieldProps} />
                    </Stack>

                    <Stack direction={'row'} alignItems='center' mt={1} >
                        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>ADD PRODUCT</Typography>
                        <IconButton onClick={addProduct}>
                            <AddCircle sx={{ color: theme.palette.custom.btn }} />
                        </IconButton>
                    </Stack>
                    {/* Show error only if products error exists */}
                    {formErrors.products && (
                        <Typography color="error" sx={{ fontSize: 13, ml: 1, mb: 1 }}>
                            {formErrors.products}
                        </Typography>
                    )}
                    <ScrollBox height={"82%"} width={"60%"} >
                        {products.map((prod, pi) => (
                            <Box key={pi} sx={{
                                px: 2, py: 2, backgroundColor: "#ffff", borderRadius: 1.4, border: 1, position: "relative", mb: 2, height: 400,
                                borderColor: '#E3E3E3', width: "100%", display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "center"
                            }}>
                                <Stack justifyContent={"center"} alignItems={"center"} width={"55%"} pl={2} gap={2}>
                                    <Stack direction={"row"} gap={2} alignItems={"center"}>
                                        <CtrlFillLabelTxtField name="lineNo" title={"POL"}  {...txtFieldProps} width={100}
                                            type="number" step={1} value={prod.lineNo} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="comProdIdStrg" title={"MATERIAL CODE"} {...txtFieldProps} width={250}
                                            value={prod.comProdIdStrg} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="prodName" title={"DESCRIPTION"}  {...txtFieldProps} width={250}
                                            value={prod.prodName} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={4}>
                                        <CtrlFillLabelTxtField name="mfrName" title={"ORIGINAL MNFR"} {...txtFieldProps} width={300}
                                            value={prod.mfrName} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlCustomDropDownOld title={"STATUS"} name={"prodStatus"} ddArr={prodStatusArr}
                                            {...txtFieldProps} width={300} value={prod.prodStatus} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={2}>
                                        <CtrlFillLabelTxtField name="orderedQty" title={"PO QTY	"}  {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.orderedQty} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="deliveredQty" title={"DELIVERED QTY"} {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.deliveredQty} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="balQty" title={"REMAINING QTY"} {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.balQty} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={2}>
                                        <CtrlFillLabelTxtField name="estTimeArr" type={"date"} title={"ETA"}  {...txtFieldProps} width={200}
                                            value={prod.estTimeArr} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlFillLabelTxtField name="expecDelDate" type={"date"} title={"ETD"} {...txtFieldProps}
                                            width={200} value={prod.expecDelDate} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlCustomDropDownOld title={"PAYMENT STATUS"} name={"isPaid"} ddArr={paidArr} {...txtFieldProps}
                                            width={200} value={prod.isPaid} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"}>
                                        <CtrlFillLabelTxtField name="amtcRemarks" title={"AMTC REMARKS"} {...txtFieldProps} width={635} multiline={true}
                                            height={70} rows={3} value={prod.amtcRemarks} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>

                                    <IconButton
                                        sx={{ position: "absolute", top: -3, left: -8 }} aria-label="delete"
                                        onClick={() => removeProduct(pi)}>
                                        <Delete color='error' />
                                    </IconButton>
                                </Stack>
                                {/* <Box width={2} bgcolor={'#E3E3E3'} height={"100%"} mx={2} /> */}
                            </Box>
                        ))}
                    </ScrollBox>
                </BgBoxOld>
            </form>
        </Stack>
    )
}

export default AddPotPage